/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/components/shared/Scale.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { _jac } from "@jac/prelude";
function count_of(counts, key) {
  if (!counts) {
    return 0;
  }
  if (_jac.poly.contains(counts, key)) {
    return _jac.poly.getitem(counts, key);
  }
  return 0;
}
function fmt_count(n) {
  let digits = String(n);
  let out = "";
  while ((digits.length > 3)) {
    out = (("," + digits.slice((digits.length - 3))) + out);
    digits = digits.slice(0, (digits.length - 3));
  }
  return (digits + out);
}
function status_key_label(key) {
  if ((key === "MISSING")) {
    return "Missing";
  }
  if ((key === "FOUND_SAFE")) {
    return "Safe";
  }
  if ((key === "INJURED")) {
    return "Injured";
  }
  if ((key === "DECEASED")) {
    return "Deceased";
  }
  if ((key === "SEEN_AT_LOCATION")) {
    return "Seen";
  }
  if ((((key === "") || (key === "NONE")) || (key === "UNKNOWN"))) {
    return "Unknown";
  }
  let words = key.replaceAll("_", " ").toLowerCase();
  return (words[0].toUpperCase() + words.slice(1));
}
function org_type_label(kind) {
  let known = {"POLICE": "Police", "HOSPITAL": "Hospital", "NGO": "Aid group", "GOVERNMENT": "Government", "POLICE_RESCUE": "Police and rescue", "COMMUNITY_NEWS": "Community news", "COMMUNITY": "Community member"};
  if ((kind in known)) {
    return known[kind];
  }
  return (kind ? status_key_label(kind) : "Organization");
}
function is_corpus_snapshot(snapshot) {
  return (_jac.builtin.bool(snapshot) && _jac.builtin.bool(snapshot.is_corpus));
}
function CorpusTotals(props) {
  const {snapshot} = props;
  let totals = snapshot.totals;
  let items = [["People", "people"], ["Claims", "claims"], ["Source reports", "sources"], ["Organizations", "organizations"], ["Media", "media"], ["Locations", "locations"]];
  let missing = snapshot.not_imported;
  let skipped = [];
  if (missing) {
    for (const key of _jac.poly.call(missing, "keys")) {
      if ((_jac.poly.getitem(missing, key) > 0)) {
        skipped.push(((String(_jac.poly.getitem(missing, key)) + " ") + _jac.poly.call(key, "replace", "_", " ")));
      }
    }
  }
  return __jacJsx("section", {"aria-label": "Corpus totals", "className": "flex flex-col gap-2"}, [__jacJsx("dl", {"className": "grid grid-cols-3 gap-2 sm:grid-cols-6"}, [(() => {
    let __jac_view_kids = [false];
    __jac_view_kids[0] = (() => {
      let __jac_view_kids_1 = [];
      for (const item of items) {
        __jac_view_kids_1.push(__jacJsx("div", {"key": item[1], "className": "min-w-0 rounded-md border border-border bg-card px-2.5 py-2"}, [__jacJsx("dt", {"className": "truncate text-[11px] text-muted-foreground"}, [item[0]]), __jacJsx("dd", {"className": "font-display text-lg leading-tight tabular-nums"}, [fmt_count(count_of(totals, item[1]))])]));
      }
      return __jac_view_kids_1;
    })();
    return __jacJsx(null, {}, __jac_view_kids);
  })()]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [__jacJsx("span", {"className": "font-medium text-status-warning"}, ["Generated exercise data, partially complete."]), (_jac.builtin.bool(skipped) ? ((" Not imported: " + skipped.join(", ")) + ".") : "")])]);
}
export {CorpusTotals, count_of, fmt_count, is_corpus_snapshot, org_type_label, status_key_label};
//# sourceMappingURL=Scale.js.map
